import * as React from "react";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {styled} from "@mui/material";
import Loading from "../components/loading";
import {toast} from "react-toastify";

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

const uri = (process.env.REACT_APP_API_URL || "").replace("graphql", "rest/iplocation");
// API Gateway rejects ~4.5MB JSON bodies (CSV expands when JSON-encoded); keep raw chunks ≤3MB.
const chunkSize = 1024 * 1024 * 3;

export default function IpUpload() {
    const [loading, setLoading] = React.useState(false);
    const [gCount, setCount] = React.useState(0);

    const upload = async (csv: string, isFirst: boolean, isLast: boolean) => {
        const response = await fetch(uri, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({csv, isFirst, isLast}),
        });
        if (!response.ok) {
            throw new Error(`Upload failed (${response.status})`);
        }
    };

    const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }

        setLoading(true);
        setCount(0);

        try {
            let start = 0;
            let count = 0;
            let chunkIndex = 0;
            const time = Date.now();

            while (start < file.size) {
                chunkIndex++;
                let csv = await file.slice(start, start + chunkSize).text();
                const lastNewLine = csv.lastIndexOf("\r\n");
                if (lastNewLine < 0) {
                    throw new Error("Invalid CSV chunk: expected CRLF line endings");
                }
                csv = csv.substring(0, lastNewLine);
                const lineCount = csv ? csv.split("\r\n").length : 0;
                count += lineCount;

                const nextStart = start + lastNewLine + 2;
                const isFirst = start === 0;
                const isLast = nextStart >= file.size;

                await upload(csv, isFirst, isLast);

                const elapsed = (Date.now() - time) / 1000;
                console.log(chunkIndex, lineCount, count, elapsed, "s");
                setCount(count);

                start = nextStart;
            }

            toast.success("File uploaded");
        } catch (err) {
            console.error(err);
            toast.error(err instanceof Error ? err.message : "Upload failed");
        } finally {
            setLoading(false);
            event.target.value = "";
        }
    };

    return (
        <>
            <h2>IP Location Upload</h2>

            <p>Upload IP-COUNTRY-REGION-CITY-LATITUDE-LONGITUDE-ISP-DOMAIN-MOBILE-USAGETYPE.CSV from IP2Location</p>

            <p>Note: Check the console log; large files may take a while</p>

            <p>Count: {gCount.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 0})}</p>

            {loading ? (
                <Loading />
            ) : (
                <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                >
                    Upload file
                    <VisuallyHiddenInput type="file" accept={".csv"} onChange={handleChange} />
                </Button>
            )}
        </>
    );
}
